import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/retour.png'


const _withScopeId = n => (_pushScopeId("data-v-270855b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "size-9"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.272-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  id: "options",
  class: "hidden"
}
const _hoisted_4 = { class: "bg-white w-96 absolute bottom-5 left-16 rounded-md p-4" }
const _hoisted_5 = { class: "flex justify-between items-center mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl text-blue-600 font-bold" }, "Parametres", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-yellow-400 text-white px-3 py-2 rounded-md w-32 text-center cursor-pointer" }, "Pause"),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-blue-400 text-white px-3 py-2 rounded-md w-32 text-center cursor-pointer" }, "Pause")
], -1))
const _hoisted_10 = { class: "flex flex-col items-center space-y-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "range",
  class: "text-sm font-medium text-gray-700"
}, " Ajustez la force de lancement initial ", -1))
const _hoisted_12 = {
  id: "output",
  class: "text-lg font-semibold text-gray-800"
}
const _hoisted_13 = { class: "flex flex-col items-center space-y-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "range",
  class: "text-sm font-medium text-gray-700"
}, " Ajustez la force de lancement initial ", -1))
const _hoisted_15 = {
  id: "output",
  class: "text-lg font-semibold text-gray-800"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-16 h-16 bg-blue-500 rounded-full",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Questions = _resolveComponent("Questions")!
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Questions, {
      id: "card",
      Presentation: "L'inertie, c’est la tendance d’un objet à rester immobile ou à continuer son mouvement si aucune force ne le dérange. C'est un principe fondamental qui explique le comportement des objets dans leur état de repos ou de mouvement.",
      titre: "Premiere loi de Newton, l'inertie",
      cacherCard: _ctx.cacherCard,
      questions: _ctx.questions,
      fichier: "principe_dynamique_inertie"
    }, null, 8, ["cacherCard", "questions"]),
    _createElementVNode("main", {
      class: _normalizeClass({ 'blur-sm': _ctx.flou == true })
    }, [
      _createElementVNode("div", {
        class: "absolute top-2 left-2 bg-white py-3 px-4 bg-white rounded-full flex justify-center items-center cursor-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.testfinal && _ctx.testfinal(...args)))
      }, " Fin de la simulation "),
      _createElementVNode("div", {
        class: "absolute bottom-2 left-2 bg-white w-16 h-16 rounded-full flex justify-center items-center",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gererVisibilite('options')))
      }, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", {
              class: "bg-red-400 text-white px-3 py-2 w-10 h-10 text-center cursor-pointer rounded-full flex items-center justify-center",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gererVisibilite('options')))
            }, _hoisted_8)
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              id: "range",
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.adjustSpeedB())),
              type: "range",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.vitesseB) = $event)),
              min: "1",
              max: "10",
              step: "1",
              value: "50",
              class: "w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            }, null, 544), [
              [_vModelText, _ctx.vitesseB]
            ]),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.vitesseB), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              id: "range",
              type: "range",
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.adjustSpeedJ())),
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.vitesseJ) = $event)),
              min: "1",
              max: "10",
              step: "1",
              value: "50",
              class: "custom-range w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            }, null, 544), [
              [_vModelText, _ctx.vitesseJ]
            ]),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.vitesseJ), 1)
          ])
        ])
      ]),
      _createVNode(_component_LoadingScreen, { isLoaded: _ctx.loaded }, null, 8, ["isLoaded"]),
      _hoisted_16,
      _createElementVNode("div", {
        class: "fixed z-40 right-2 bottom-5 w-16 h-16",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.actualiser && _ctx.actualiser(...args)))
      }, _hoisted_18)
    ], 2)
  ], 64))
}